<template>
    <div class="col-lg-2 col-md-2 col-xs 6 content-functionality">
        <div class="options-rules">
            <h3 class="functionTitleUser">{{ getTranslate(getValueObject(funct, "terms.name")) }}</h3>
            <div class="function">
                <ul>
                    <li class="listNone" v-for="role in listRoles" :key="role.id">
                        <input
                            type="radio"
                            v-model="selectedRole"
                            :name="'functionality_' + funct.id"
                            :id="'role_' + '_' + funct.id + '_' + role.id"
                            :value="role.id"
                        />
                        <label :for="'role_' + role.id + '_' + funct.id"> {{ getTranslate(role.terms.name) | lowercase }} </label>
                    </li>
                    <li class="listNone">
                        <input
                            type="radio"
                            v-model="selectedRole"
                            :name="'functionality_' + funct.id"
                            :id="'role_' + '_' + funct.id + '_none'"
                            :value="null"
                        />
                        <label :for="'role_' + 'none' + '_' + funct.id + '_none'"> {{ $t("userrole.none") }} </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import cacheService from "@/services/cache";

export default {
    components: {},
    props: {
        funct: {
            type: Object,
            required: true
        },
        value: {},
        listRoles: {
            type: Array,
            required: true
        },
        currentRole: {
            required: false
        }
    },
    computed: {
        selectedRole: {
            get() {
                return this.currentRole;
            },
            set(value) {
                let role = this.listRoles.find(role => role.id === value) || { id: null };
                this.$emit("updateRole", this.funct, role);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.content-functionality {
    .options-rules {
        padding: 0 10px;
        background-color: white;
        border: 1px solid #ccc;
        margin: 10px 0;
        .functionTitleUser {
            font-family: "Oswald", Sans-Serif;
            font-weight: normal;
            font-size: 18px;
            color: #2d2d2d;
            min-height: 40px;
            &::first-letter {
                text-transform: capitalize;
            }
        }
        ul {
            padding: 0;
        }
        input[type="radio"] {
            vertical-align: middle;
            height: 15px;
            width: 15px;
        }
        label {
            vertical-align: middle;
            margin-left: 5px;
            font-family: "oswald-regular", sans-serif;
        }
    }
}
.listNone {
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// FunctionalitySection.vue?47b31a1c